"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _TwFlag = createIcon({
  displayName: "_TwFlag",
  viewBox: "0 0 640 480",
  path: (
    <>
      <g>
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="M 562.97143,216.93996 A 130.67719,130.67719 0 0 0 443.08306,86.642581 a 130.72852,130.72852 0 0 0 -246.14122,0 A 130.67719,130.67719 0 0 0 123.93507,317.17029 130.75931,130.75931 0 0 0 320.00218,460.12477 130.80038,130.80038 0 0 0 516.0693,317.17029 130.36923,130.36923 0 0 0 562.97143,216.93996 Z"
        />
        <path
          fill="#003283"
          strokeWidth={1.02653}
          d="M 562.97143,216.93996 A 130.67719,130.67719 0 0 0 443.08306,86.642581 a 130.72852,130.72852 0 0 0 -246.14122,0 A 130.67719,130.67719 0 0 0 123.93507,317.17029 130.75931,130.75931 0 0 0 320.00218,460.12477 130.80038,130.80038 0 0 0 516.0693,317.17029 130.36923,130.36923 0 0 0 562.97143,216.93996 Z m -69.75268,88.14808 A 108.9353,108.9353 0 0 1 322.29134,431.04319 108.94557,108.94557 0 0 1 150.65563,306.75101 108.92503,108.92503 0 0 1 208.37738,105.46913 c 2.26863,0 4.47566,0 6.6827,0.22584 a 108.91477,108.91477 0 0 1 211.14683,0 c 2.20704,-0.18478 4.45514,-0.22584 6.68271,-0.22584 a 108.91477,108.91477 0 0 1 60.32913,199.59838 z"
        />
        <path
          fill="#e41f20"
          strokeWidth={1.02653}
          d="M 527.16608,217.17606 A 99.737597,99.737597 0 0 0 427.39769,117.3666 c -3.14118,0 -6.32342,0.18478 -9.42354,0.44141 a 99.758127,99.758127 0 0 0 -194.66077,0 c -3.07959,-0.25663 -6.22077,-0.44141 -9.36195,-0.44141 a 99.747862,99.747862 0 0 0 -49.95092,186.14058 99.768392,99.768392 0 0 0 158.24977,113.82158 99.778658,99.778658 0 0 0 157.57227,-115.32031 99.573352,99.573352 0 0 0 47.34353,-84.83239 z m -64.28127,78.55003 A 87.593754,87.593754 0 0 1 321.88073,399.24131 87.614284,87.614284 0 0 1 180.04516,296.92713 a 87.604019,87.604019 0 0 1 54.40606,-165.89742 87.583488,87.583488 0 0 1 174.15072,-0.58512 87.583488,87.583488 0 0 1 54.31367,165.27123 z"
        />
        <path
          fill="#003283"
          strokeWidth={1.02653}
          d="m 321.78834,96.836017 a 60.493378,60.493378 0 1 0 60.56524,60.472843 60.503643,60.503643 0 0 0 -60.56524,-60.472843 z m 0,89.657073 a 29.173966,29.173966 0 1 1 29.20477,-29.18423 29.1637,29.1637 0 0 1 -29.2253,29.1945 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 314.56158,124.03905 h 15.22343 l -7.2473,-23.15851 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 298.86594,132.1281 13.17038,-7.59632 -17.87188,-16.49633 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 289.31922,146.98198 7.61685,-13.19091 -23.70257,-5.30715 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 288.48773,164.58696 v -15.21317 l -23.16877,7.18571 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 296.57678,180.26206 -7.60658,-13.17037 -16.42447,17.87188 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 311.39987,189.81905 -13.14984,-7.60658 -5.34822,23.70256 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 329.01511,190.6608 h -15.2029 l 7.25756,23.19957 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 344.73128,182.57175 -13.20117,7.59632 17.90267,16.42447 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 354.23694,167.71787 -7.58605,13.17037 23.72309,5.30716 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 355.08896,150.12316 v 15.2029 l 23.19956,-7.23703 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 347.04097,134.43779 7.59632,13.17037 16.42447,-17.87188 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 332.18709,124.8808 13.17037,7.59632 5.29689,-23.6923 z"
        />
        <path
          fill="#fff"
          strokeWidth={1.02653}
          d="m 394.73352,308.41399 a 74.741606,74.741606 0 1 1 -74.7416,-74.73134 74.741606,74.741606 0 0 1 74.7416,74.73134"
        />
      </g>
      <g transform="matrix(0.20655911,0,0,0.20655911,203.72635,345.38226)">
        <path
          fill="#ddda45"
          d="m 378.94821,-82.4139 0.0173,-219.96377 190.14321,109.81717 -0.20509,218.9279 C 505.27033,-9.3445518 378.94821,-82.4139 378.94821,-82.4139 Z m 146.8851,28.0467 c 0,-12.8794 -0.18785,-15.0047 -1.45637,-16.4848 -0.80099,-0.9346 -17.74687,-10.5804 -37.65751,-21.4352 -39.42884,-21.4957 -43.11734,-23.7008 -48.34577,-28.9025 -6.35668,-6.3241 -6.38498,-6.4874 -6.709,-38.716 -0.27837,-27.6876 -0.23649,-28.6061 1.36101,-29.7755 3.33671,-2.4428 2.77429,-2.7068 51.01484,23.9423 42.21421,23.3199 40.0044,22.2086 41.00746,20.6232 0.4179,-0.6605 0.7656,-7.8068 0.77262,-15.8805 0.0123,-12.806 -0.17306,-14.891 -1.44365,-16.3366 -1.69762,-1.9317 -79.42814,-45.0687 -85.54321,-47.4727 -14.15961,-5.5667 -23.08701,-3.2054 -27.74994,7.3399 -2.87751,6.5075 -3.41206,13.5011 -3.4028,44.5182 0.0123,40.5305 1.67261,51.2887 10.14752,65.7446 4.12576,7.0375 15.55061,18.6858 23.22072,23.675 3.0309,1.9715 22.87912,13.0527 44.10716,24.6248 28.1953,15.3702 38.87673,20.8086 39.63666,20.1809 0.76092,-0.6286 1.04026,-4.8295 1.04026,-15.6451 z m 47.85208,-365.7467 c -0.024,-22.87397 -0.0461,-34.6309 -0.36171,-66.6535 120.72052,-0.20391 209.16095,73.39724 250.21116,144.64173 -51.70988,30.08713 -57.38751,33.35974 -57.38751,33.35974 -37.92855,-64.86818 -110.15284,-110.57228 -192.46194,-111.34797 z"
        />
        <path
          fill="#e7762a"
          d="m 768.51842,-82.684194 c 41.54138,-74.988706 34.9409,-159.138396 -0.0341,-222.019506 0.45369,-1.1825 38.32522,-22.14818 57.38318,-33.37066 58.66,107.44561 41.82569,216.70743 0.16275,288.696156 -23.31082,-13.08668 -35.58051,-20.368143 -57.51178,-33.30599 z"
        />
        <path
          fill="#e02826"
          d="m 573.67282,-192.56755 c 64.29262,-37.49558 189.67915,-108.93736 189.67915,-108.93736 -0.77393,146.84157 0.0609,9.34343 -0.24972,219.153082 -62.29182,37.076349 -120.40404,69.866445 -189.42943,108.719228 -0.36127,-46.067781 0,-53.392254 0,-218.93495 z m 57.43508,145.76665 4.99325,-3.005 7.48994,-21.6244 7.48987,-21.6245 26.61348,-14.7718 c 14.63741,-8.1244 26.87858,-14.7717 27.20257,-14.7717 0.32395,0 3.28055,4.8844 6.57015,10.8541 3.28963,5.9697 6.63229,11.6583 7.42828,12.6413 l 1.44723,1.7872 9.46808,-5.3757 c 5.20736,-2.9567 9.58642,-5.9912 9.73134,-6.7433 0.14473,-0.7521 -8.12365,-17.2226 -18.37445,-36.601 -10.25077,-19.3784 -21.94483,-41.5295 -25.98685,-49.2246 -7.95376,-15.1424 -9.69987,-17.0351 -14.7018,-15.9364 -3.23279,0.71 -8.17517,5.6546 -10.40105,10.4057 -0.95594,2.0405 -9.99552,27.1158 -20.08792,55.723 -10.0924,28.6072 -22.69592,64.2922 -28.00783,79.2998 -5.31191,15.0076 -9.42534,27.6631 -9.14102,28.1232 0.50533,0.8176 7.61795,-2.7475 18.26673,-9.1559 z m 39.33889,-102.7525 c 3.99568,-11.7121 7.58728,-21.1914 7.98129,-21.0652 1.17232,0.3758 14.79402,25.5243 14.27761,26.3598 -0.46401,0.7508 -25.23653,14.3861 -28.08432,15.4582 -1.12476,0.4234 0.14873,-4.1138 5.82542,-20.7528 z m -354.34287,-187.95476 57.66718,32.38539 c -40.29696,80.9231 -36.51812,142.25774 -0.32872,222.33678 l -57.41881,32.897031 c -57.75083,-104.048031 -41.37164,-214.335501 0.0804,-287.619201 z"
        />
        <path
          fill="#3d9c46"
          d="m 318.88136,-342.33612 c 44.33447,-80.28663 142.73158,-144.58165 249.81078,-144.35418 v 66.5768 c -91.5423,3.25862 -154.86232,49.70195 -192.57246,110.94732 -21.80068,-12.61181 -32.43774,-18.8683 -57.23832,-33.16994 z"
        />
        <path
          fill="#eeeeec"
          d="M 375.79609,-78.705606 C 418.02494,-8.400441 492.50271,31.902242 568.84357,32.845032 l 0.0601,65.733068 C 468.67166,99.192922 370.96205,44.711786 318.49119,-45.589701 Z"
        />
        <path
          fill="#304a96"
          d="m 573.684,98.65 c -0.53643,-22.000348 -0.14592,-43.795975 0.002,-65.805334 90.2757,0.02478 164.87199,-60.801773 192.39794,-111.297767 24.80027,14.313198 34.06987,19.70304 57.53369,33.240121 C 774.79127,38.593606 678.48894,99.202077 573.68461,98.65 Z m -191.79896,-404.7507 189.29399,-109.0195 189.59581,109.4965 -189.38407,108.9089 z m 156.12074,59.6616 c 1.8619,-0.9499 3.94505,-2.5913 4.62923,-3.6475 0.68418,-1.0562 7.14246,-13.2489 14.35183,-27.0948 7.20928,-13.8459 13.36854,-25.1743 13.6872,-25.1743 0.31862,0 6.55669,11.6423 13.86239,25.8717 9.12423,17.7716 14.12647,26.6196 15.97682,28.2602 5.52355,4.8973 15.957,5.3847 22.22718,1.0383 3.11324,-2.1581 5.16527,-5.9004 26.52975,-48.3828 12.73554,-25.3241 22.95226,-46.5735 22.70384,-47.2209 -0.36402,-0.9486 -3.08097,-1.1746 -14.00121,-1.1643 -7.45227,0.01 -13.9729,0.2879 -14.49036,0.6242 -0.5175,0.3362 -7.75215,14.2361 -16.07706,30.8884 -8.41977,16.8422 -15.44834,29.9516 -15.83964,29.5435 -0.38693,-0.4035 -6.40913,-11.7812 -13.38277,-25.2838 -6.97365,-13.5026 -13.60973,-25.8081 -14.74692,-27.3455 -5.58649,-7.5527 -18.99772,-7.7743 -25.18097,-0.416 -1.12534,1.3392 -8.03801,13.9343 -15.36147,27.989 -7.32343,14.0548 -13.51638,25.5579 -13.76209,25.5626 -0.24574,0.01 -6.97247,-13.1925 -14.9484,-29.327 -7.97589,-16.1345 -15.04195,-29.9908 -15.7023,-30.7918 -1.05072,-1.2745 -2.82116,-1.4547 -14.17894,-1.4436 -7.13809,0.01 -13.50438,0.3458 -14.1473,0.7528 -1.28275,0.8121 5.24946,15.0776 30.1353,65.8113 13.38856,27.2946 15.09224,29.8906 21.0805,32.1204 4.29691,1.6001 12.31022,1.0364 16.63539,-1.1701 z"
        />
        <g transform="matrix(2.000044,0,0,2.000044,910.09622,-636.42109)">
          <g transform="matrix(0.12458447,0,0,0.12458447,-46.754768,344.21344)">
            <g transform="translate(-93.696521,-2082.5864)">
              <circle
                cx="87.887909"
                cy="2073.0198"
                r="88.5"
                fill="none"
                stroke="#000000"
                strokeWidth="20"
              />
              <path d="m 82.487909,2065.0198 c 5.5,0 9.5,-1.1 11.9,-3.2 2.4,-2 3.7,-5.4 3.7,-10.2 0,-4.7 -1.3,-8 -3.7,-10.1 -2.4,-2 -6.4,-3 -11.9,-3 h -11.2 v 26.5 h 11.2 m -11.2,18.3 v 39 H 44.687911 v -103.1 h 40.599998 c 13.6,0 23.5,2.3 29.8,6.9 6.4,4.5 9.5,11.7 9.5,21.6 0,6.8 -1.6,12.4 -4.9,16.8 -3.3,4.3 -8.2,7.6 -14.9,9.6 3.7,0.9 6.9,2.8 9.8,5.7 2.9,2.9 5.8,7.3 8.7,13.3 l 14.5,29.2 h -28.3 l -12.6,-25.6 c -2.5,-5.1 -5.1,-8.7 -7.7,-10.5 -2.6,-1.9 -6.1,-2.9 -10.4,-2.9 h -7.5" />
            </g>
          </g>
        </g>
      </g>
    </>
  ),
  defaultProps: {
    bg: "white",
    aspectRatio: "landscape",
    height: "auto",
  },
});

export default _TwFlag;
